import './commons/global-setup'
import './scss/common/style.scss'
import { setUrlParam } from './shared/url-utils'
import { focusContentAfterSearchNavigation } from './apps/new-experience-portal/global-search/search-navigation-focus'

const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
}

const jcs = `topbar-zw-${isMobileDevice() ? 'mBrw' : 'pcBrw'}`

async function initApplication() {
  try {
    const [{ MicroAppBootstrap }, { microAppsConfig }, trackingManagerModule] = await Promise.all([
      import('./core/MicroLoader').catch((err) => {
        console.error('[Main] Failed to load MicroLoader:', err)
        throw err
      }),
      import('./config/microApps.config').catch((err) => {
        console.error('[Main] Failed to load microApps.config:', err)
        throw err
      }),
      import('./apps/telemetry').catch((err) => {
        console.warn('[Main] Failed to load telemetry:', err)
        return { default: { initTelemetryTracker: () => {} } }
      })
    ])

    const bootstrap = new MicroAppBootstrap(microAppsConfig)
    bootstrap.loadConfig(window.microsDatas || {})
    await bootstrap.bootstrap()

    const failedAppsCount = bootstrap.failedApps.size
    if (failedAppsCount > 0) {
      console.warn(
        `[Bootstrap] ${failedAppsCount} app(s) failed to load, but the application is running:`,
        Array.from(bootstrap.failedApps)
      )
    }

    if (window.__failedChunks && window.__failedChunks.size > 0) {
      console.warn(
        `[Bootstrap] ${window.__failedChunks.size} chunk(s) failed to load:`,
        Array.from(window.__failedChunks)
      )
    }

    const trackingManager = trackingManagerModule?.default
    if (typeof window !== 'undefined') {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
          trackingManager?.initTelemetryTracker?.()
        })
      } else {
        setTimeout(() => {
          trackingManager?.initTelemetryTracker?.()
        }, 0)
      }
    }
    const mainContentLink = document.getElementById('the-main-content')
    if (mainContentLink?.tagName === 'A' && mainContentLink.textContent.trim() === '') {
      const contentBody = mainContentLink.closest('.content-body')
      if (contentBody && !contentBody.id) {
        contentBody.id = 'the-main-content'
        contentBody.removeAttribute('role')
        mainContentLink.remove()
      }
    }
    focusContentAfterSearchNavigation()
    const jecSelectors = ['#btnJoinMeeting', '#hostMeetingDropdown > li > a']
    jecSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (el.tagName === 'A' && el.href) {
          el.href = setUrlParam(el.href, 'jcs', jcs) || el.href
        }
      })
    })
  } catch (error) {
    console.error('[Bootstrap] Critical error during initialization:', error)
    console.warn('[Bootstrap] Some core features may not work, but attempting to continue...')
  }
}

initApplication()
